<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div class="table-container">
  <table id="order-search-payment-list" mat-table orbitStickyTable [orbitStickyTable]="{ stickyRowActions: false }" [orbitTableDashboard]="false" [dataSource]="payments" class="mat-elevation-z2">
    <!-- Description -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
      <td mat-footer-cell *matFooterCellDef class="info-label">Total</td>
    </ng-container>
    <!-- Payment Amount -->
    <ng-container matColumnDef="paymentAmount">
      <th mat-header-cell *matHeaderCellDef  class="right"> Amount </th>
      <td mat-cell *matCellDef="let item"  class="right"> {{ item.amount | number:'1.2-2' }} </td>
      <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotalAmount | number:'1.2-2' }} </td>
    </ng-container>

    <!-- Payment Date -->
    <ng-container matColumnDef="paymentDate">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let item"> {{ item.paymentDate | date:'dd/MM/yyyy' }} </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>


    <!-- Header & Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>
</div>
